import React from "react";
import CommonModal from "Pages/PhishingManager/components/Modal";
import { ModalProps } from "Pages/PhishingManager/components/Modal/Modal.types";

const ExitCampaignModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (

    <CommonModal
      visible={open}
      confirmText="Exit and discard setup"
      cancelText="Continue setup"
      iconType={null}
      modalTitle="Exit campaign setup?"
      modalContentDesc={[
        "If you exit now, all progress in this campaign setup will be lost.",
        "This campaign has not been started and no emails will be sent."
      ]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default ExitCampaignModal;